// extracted by mini-css-extract-plugin
export default {"cardWrapper":"LegalBlock_cardWrapper__phqdd","card":"LegalBlock_card__Z50ft","contentWrapper":"LegalBlock_contentWrapper__YxmxQ"};